<div>{{arrayEditor.name}}</div>